const mediaItems = [
  {
    title: '《剑尊归来》精彩片段赏析',
    desc: '高燃打斗场景回顾，感受顶级韩漫画风魅力',
    duration: '03:25',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20action%20scene%20illustration%20of%20a%20martial%20arts%20warrior%20in%20mid%20combat%20with%20dynamic%20motion%20lines%20and%20energy%20effects%2C%20sword%20clashing%20with%20explosive%20impact%2C%20warm%20orange%20and%20crimson%20color%20palette%2C%20cinematic%20composition%20with%20dramatic%20lighting%2C%20modern%20digital%20art%20style%20with%20anime%20influence%2C%20perfect%20for%20a%20manga%20video%20thumbnail%20on%20a%20reading%20platform&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '妖精动漫平台使用指南',
    desc: '快速上手，教你如何高效追漫与收藏',
    duration: '02:10',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20friendly%20illustration%20of%20a%20tablet%20device%20displaying%20a%20colorful%20manga%20reader%20interface%20with%20comic%20panels%2C%20surrounded%20by%20helpful%20UI%20elements%20like%20bookmarks%20and%20navigation%20arrows%2C%20clean%20and%20modern%20design%2C%20bright%20and%20inviting%20color%20palette%20with%20soft%20pastels%2C%20minimal%20composition%2C%20digital%20illustration%20style%20with%20flat%20design%20elements%2C%20perfect%20for%20a%20platform%20tutorial%20thumbnail&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '暑期新番推荐合集',
    desc: '一次性看完本月最值得追的10部作品',
    duration: '05:48',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20colorful%20collage%20illustration%20of%20various%20manga%20characters%20from%20different%20genres%20arranged%20in%20a%20dynamic%20circular%20composition%2C%20action%20heroes%20romance%20couples%20and%20fantasy%20creatures%20all%20united%2C%20vibrant%20and%20diverse%20color%20palette%2C%20energetic%20and%20exciting%20atmosphere%2C%20clean%20composition%20with%20balanced%20visual%20weight%2C%20modern%20anime%20style%20digital%20illustration%2C%20perfect%20for%20a%20manga%20recommendation%20video%20thumbnail&width=640&height=360&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            精彩视频
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            漫画世界的视觉盛宴，精彩内容先睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href={`#media`}
              onClick={(e) => e.preventDefault()}
              className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.imageUrl}
                  alt={`妖精动漫 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-black/60 text-white">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}